const PageColumn = ({ children }) => (
  <div className="w-full sm:w-1/2 sm:mx-0 flex flex-col">{children}</div>
);

export default PageColumn;
